import { fetchToken } from "../../../common/FetchCookie";
const API = "https://api.indiahirings.com/api/auth/reset-password";
export const confirmPasswordReset = async ({
  email,
  code,
  password,
  password_confirmation,
}) => {
  try {
    const response = await fetch(`${API}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, code, password, password_confirmation }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to reset password");
    }

    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

